import "./Header.scss";
import logo from './../../common/assets/img/AMIG-Logo.png';
import appSettings from '../../appSettings';

export default function Header() {
  
    
  return (
    <header className=' header-content drop-shadow-divider'>
      <div className='header-container'>
        <div className='section-left'>
          <div className='logo-container'>
          <a href={appSettings.AEM_AGENTS_BASE_URL} aria-label="amig-logo">
            <img className="logo-img" src={logo} alt='Amig_Logo' />
          </a>
          </div>
        </div>
        <div className='section-right'>
          <button className="secondary-button-theme" id="amod-return-login-button">Return to Login</button>
        </div>
        </div>
      </header>
  );
}

